import type { ChangeEventHandler, RefObject } from 'react';
import { createContext, createRef } from 'react';

export interface OptionContextInterface {
  name?: string;
  disabled?: boolean;
  onChange?: ChangeEventHandler;
  onClick?: (value: string) => void;
  selectedValue?: string;
  selectedRef?: RefObject<HTMLInputElement>;
}

export default createContext<OptionContextInterface>({
  selectedRef: createRef()
});
